/* ONE — Parallaxe images au scroll
   Applique un translateY subtil sur les images marquées [data-parallax]
   ou .one-parallax pour créer une sensation de profondeur 3D premium.
   Respecte prefers-reduced-motion. */
(function(){
  if (typeof window === 'undefined') return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if ('IntersectionObserver' in window === false) return;

  // Sélecteurs des éléments à parallaxer
  var SELECTORS = [
    '.one-creatrice__portrait',
    '.one-banner-video__poster-img',
    '.one-coll-hero__bg',
    '.one-citation__bg img',
    '.one-collabs__slide img',
    '.one-galerie__card img'
  ].join(',');

  var elements = [];

  function rebuild(){
    elements = [];
    document.querySelectorAll(SELECTORS).forEach(function(el){
      var rect = el.getBoundingClientRect();
      // Set will-change for perf
      el.style.willChange = 'transform';
      // Optional: scale légèrement (105%) pour cacher les bords lors du parallax
      var cs = getComputedStyle(el);
      if (!el.dataset.parallaxInited) {
        el.dataset.parallaxInited = '1';
        var transform = cs.transform === 'none' ? '' : cs.transform;
        el.dataset.originalTransform = transform;
        // Ne pas modifier les éléments avec object-fit cover qui dépendent de leurs dimensions
        if (!cs.objectFit || cs.objectFit === 'cover' || cs.objectFit === 'fill') {
          el.style.transform = transform + ' scale(1.06)';
        }
      }
      elements.push(el);
    });
  }

  var ticking = false;
  var vh = window.innerHeight;

  function update(){
    elements.forEach(function(el){
      var rect = el.getBoundingClientRect();
      // Skip if not in viewport
      if (rect.bottom < 0 || rect.top > vh) return;
      // Calcule progress -1 (haut viewport) à 1 (bas viewport)
      var center = rect.top + rect.height / 2;
      var progress = (center - vh / 2) / vh; // -0.5 à 0.5 environ
      // Translate Y modéré : maxi 50px haut / 50px bas
      var translate = progress * -30; // image bouge à l'inverse du scroll
      var baseTransform = el.dataset.originalTransform || '';
      var hasScale = el.style.transform.indexOf('scale') !== -1;
      el.style.transform = baseTransform + ' translateY(' + translate.toFixed(1) + 'px)' + (hasScale ? ' scale(1.06)' : '');
    });
    ticking = false;
  }

  function onScroll(){
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  }

  function init(){
    rebuild();
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function(){
      vh = window.innerHeight;
      rebuild();
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init on Shopify section reload
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', rebuild);
  }
})();
